import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { listAccessibleGroupsAPI } from "../store/features/listGroup";
import { ListCoRoleName } from "../store/features/ListCoUserByRole";
import { mapGroupListItem, mapAgentListItem } from "../utils/teamMappers";

export default function useTeamFormOptions() {
  const dispatch = useDispatch();
  const [groupOptions, setGroupOptions] = useState([]);
  const [agentOptions, setAgentOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const [groupsRes, agentsRes] = await Promise.all([
          dispatch(listAccessibleGroupsAPI()),
          dispatch(ListCoRoleName({ name: "agent,admin,admin_with_billing" })),
        ]);
        if (cancelled) return;

        if (groupsRes?.payload?.status === 200) {
          setGroupOptions(
            (groupsRes.payload.data || []).map(mapGroupListItem).filter((g) => g.id)
          );
        }

        const agentData = agentsRes?.payload?.data ?? agentsRes?.payload;
        const agentList = Array.isArray(agentData) ? agentData : agentData?.data || [];
        if (agentsRes?.payload?.status === 200 || agentList.length) {
          setAgentOptions(agentList.map(mapAgentListItem).filter((a) => a.id));
        }
      } catch {
        if (!cancelled) toast.error("Failed to load groups or agents");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return { groupOptions, agentOptions, loading };
}
